
















import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  props: ['propertyName'],
  data(): {
    barChartOptions: ApexOptions;
    barSeries: any;
  } {
    const keyForSchema = '/' + this.propertyName.replace(/\./g, '/');
    const schemaAnalysisResult = this.$store.getters.schemaAnalysisResult;
    const totalCount =
      this.$store.getters.labelAnalysisResult[this.propertyName].count;
    const violationInfo = schemaAnalysisResult.violationPerProp[keyForSchema];
    const errorCount = violationInfo.count;

    let goodPercent = (((totalCount - errorCount) / totalCount) * 100).toFixed(
      2,
    );

    if (errorCount !== 0 && goodPercent === '100.00') {
      goodPercent = '99.99';
    }

    const errorPercent = ((errorCount / totalCount) * 100).toFixed(2);

    return {
      barChartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: true,
            tools: {
              selection: false,
              zoom: false,
              zoomout: false,
              zoomin: false,
              pan: false,
              reset: false,
            },
          },
          width: '100%',
        },
        colors: ['#5BD99C', '#FC5E54'],
        xaxis: {
          labels: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        fill: {
          opacity: 1,
        },
        legend: {
          horizontalAlign: 'left',
          position: 'bottom',
          fontSize: '12px',
          show: true,
        },
        dataLabels: {
          formatter: function (val) {
            let rtData = String(Math.round((val as number) * 100) / 100) + '%';

            if (val !== 100 && rtData === '100%') {
              rtData = '99.99%';
            }

            return val !== 0 ? rtData : '';
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
          },
        },
      },
      barSeries: [
        { name: `정상 (${goodPercent}%)`, data: [totalCount - errorCount] },
        { name: `구문 오류 (${errorPercent}%)`, data: [errorCount] },
      ],
    };
  },
  computed: {},
});
